export default {
  get_all: { method: 'get', url: 'api/states' },
  show: { method: 'get', url: 'api/states{/id}' },
  store: { method: 'post', url: 'api/states' },
  update: { method: 'put', url: 'api/states{/id}'},
  delete: { method: 'delete', url: 'api/states{/id}' }
}
